import config from '../../config';
import Component from '../Component';
import Lookup from './Lookup';
import React from 'react';

export default class FolderLookup extends Component {

	api(q, page) {
		const client = config.getApiClient;
		return client.call('folder.lookup', {q: q, page: page, client: this.props.client});
	}

	render() {
		return <Lookup  query={(q, page) => this.api(q, page)}
						{...this.props} />
	}
}


// WEBPACK FOOTER //
// ./src/components/Form/FolderLookup.js